const ASSISTANT_NOT_INCLUDED = "zz_SubscriptionApiErrorCode_AiAccessNotIncluded";

export const ASSISTANT_NOT_INCLUDED_NOTE = "Organisasjonen din har ikke tilgang til denne funksjonen.";

export const isAssistantNotIncluded = (error: unknown): boolean => {
  const e = error as { status?: unknown; data?: { errorCode?: unknown } } | null | undefined;
  return e?.status === 403 && e.data?.errorCode === ASSISTANT_NOT_INCLUDED;
};
